<p>
  attendees-editor works!
</p>
